import { Box, Icon, Text } from '@zillow/constellation-10';
import { IconCheckmarkCircleFilled } from '@zillow/constellation-icons';

// Phrasing content only, since it renders inside a <legend>.
export const SavedIndicator = () => {
  return (
    <Box asChild css={{ display: 'flex', alignItems: 'center', gap: 'tighter' }}>
      <span>
        <Text textStyle="body-sm" css={{ color: 'text.feedback.success.hero' }}>
          Saved
        </Text>
        <Icon css={{ color: 'text.feedback.success.hero' }} size="sm">
          <IconCheckmarkCircleFilled />
        </Icon>
      </span>
    </Box>
  );
};
